import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'

Vue.use(VueRouter)

export const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Sidebars.vue'),
    meta: {
      title: '我的账号',
      menuLabel: '账号中心'
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          title: '账号中心 - 账号信息',
          menuLabel: '账号信息',
          icon: 'ds-icon-leader',
          name: 'account',
        },
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'login' */ '../views/Login.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/password/edit',
    name: 'EditPassword',
    component: () => import(/* webpackChunkName: 'forget-password' */ '../views/EditPassword.vue'),
    meta: {
      title: '修改密码',
    },
  },
  {
    path: '/password/reset',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: 'reset-password' */ '../views/ResetPassword.vue'),
    meta: {
      title: '重置密码',
    },
  },
  {
    path: '/o/oauth2/login',
    name: 'AuthorizeLogin',
    component: () => import('@/views/OAuth/OAuthView.vue'),
    meta: {
      title: '授权登录',
    },
  },
  {
    path: '/o/oauth2/authorize',
    name: 'Authorize',
    component: () => import('@/views/OAuth/OAuthView.vue'),
    meta: {
      title: '授权认证',
    },
  },
  {
    path: '/audit',
    name: 'OperationLog',
    component: () => import('../views/OperationLog.vue'),
    meta: {
      title: '操作日志',
    },
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'),
    meta: {
      title: '非法访问',
    },
  },
  {
    path: '/o/register/success',
    name: 'RegisterSuccess',
    component: () => import('../views/register/RegisterSuccess.vue'),
    meta: {
      title: '认证成功',
    },
  },
  {
    path: '/o/certificate/success',
    name: 'CertificateSuccess',
    component: () => import('../views/register/CertificateSuccess.vue'),
    meta: {
      title: '完善成功',
    },
  },
  {
    path: '/o/register',
    name: 'Register',
    component: () => import('../views/register/Register.vue'),
    meta: {
      title: '注册账号流程',
    },
    children: [
      {
        path: '',
        redirect: 'select'
      },
      {
        path: 'select',
        redirect: 'submit'
      },
      {
        path: 'submit',
        name: 'AccountDetail',
        component: () => import('../views/register/Register.vue'),
        meta: {
          title: '注册账号',
        },
      },
    ],
  },
  {
    path: '/o/certificate',
    name: 'Certificate',
    component: () => import('../views/register/Certificate.vue'),
    meta: {
      title: '完善认证信息',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

const loginFreeRouteNames = [
  'ResetPassword',
  'Error',
  'ModeSelect',
  'AccountDetail',
  'RegisterSuccess',
  'Certificate',
  'CertificateSuccess',
]
router.beforeEach(async (to, from, next) => {
  if (to.meta?.title) {
    document.title = `${to.meta.title} | 账号中心`
  }
  await store.dispatch('getAccount')
  const isRouteAuthFree = [...loginFreeRouteNames, 'Login'].includes(`${to.name}`) || to.path.startsWith('/o/oauth2')
  if (!isRouteAuthFree && !store.state.userData?.userId) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && store.state.userData?.userId) {
    if (to.query.redirect_url) {
      location.replace(`${to.query.redirect_url}`)
    } else {
      next({ name: 'Home' })
    }
  } else {
    next()
  }
})

export default router
